import useSprite from './useSprite.hook';
import { StyledSprite } from './Sprite.styled';
import { useContext } from 'react';
import { GameAssetsContext } from '../../GameAssetsContext/GameAssetsContext';
import { GameStageContext } from '../../GameStageContext/GameStageContext';
import useTransform from '../SimpleImage/useTransfrom.hook';

export default function Sprite({
  spriteId,
  transform,
  relativeTo,
  animId,
  onClick,
  onAnimationLastFrame,
  onStart,
  onEnd,
  debug,
  innerRef,
  spriteScale,
  className = '',
}) {
  const gameStage = useContext(GameStageContext);
  const gameAssets = useContext(GameAssetsContext);

  const { state, actions } = useSprite({
    spriteId,
    animId,
    gameAssets,
    gameStage,
    onAnimationLastFrame,
  });
  const { responsiveTransform, originalSize } = useTransform({
    transform,
    relativeTo,
    currentFrame: state.currentFrame,
    spriteScale,
  });
  //console.log(state.currentFrame, responsiveTransform, originalSize);
  return (
    <>
      {state.currentFrame && responsiveTransform && (
        <StyledSprite
          onClick={onClick}
          responsiveTransform={responsiveTransform}
          originalSize={originalSize}
          currentFrame={state.currentFrame}
          className={className}
        >
          <div className="sprite-wrapper">
            <div className="reference" ref={innerRef}></div>
            <img
              className="sprite"
              src={gameAssets.state.sprites[spriteId].image}
              alt="sprite gameObject"
            />
            {debug && (
              <div className="grid">
                <div className="grid-box"></div>
                <div className="grid-box"></div>
                <div className="grid-box"></div>
                <div className="grid-box"></div>
              </div>
            )}
          </div>
        </StyledSprite>
      )}
    </>
  );
}
